import { TFunction } from 'i18next';
import { TRANSFER_FILTERS_STATUS } from '.';

export const transfersStatusFilters = (t: TFunction) => [
  {
    id: TRANSFER_FILTERS_STATUS.ALL_TRANSFERS,
    name: TRANSFER_FILTERS_STATUS.ALL_TRANSFERS,
    label: t('innerLayout.balanceTransfers.transfers.tabs.allTransfers'),
  },
  {
    id: TRANSFER_FILTERS_STATUS.INITIATED,
    name: TRANSFER_FILTERS_STATUS.INITIATED,
    label: t('innerLayout.balanceTransfers.transfers.tabs.initiated'),
  },
  {
    id: TRANSFER_FILTERS_STATUS.IN_REVIEW,
    name: TRANSFER_FILTERS_STATUS.IN_REVIEW,
    label: t('innerLayout.balanceTransfers.transfers.tabs.inReview'),
  },
  {
    id: TRANSFER_FILTERS_STATUS.ON_ITS_WAY,
    name: TRANSFER_FILTERS_STATUS.ON_ITS_WAY,
    label: t('innerLayout.balanceTransfers.transfers.tabs.onItsWay'),
  },
  {
    id: TRANSFER_FILTERS_STATUS.SETTLED,
    name: TRANSFER_FILTERS_STATUS.SETTLED,
    label: t('innerLayout.balanceTransfers.transfers.tabs.settled'),
  },
  {
    id: TRANSFER_FILTERS_STATUS.FAILED,
    name: TRANSFER_FILTERS_STATUS.FAILED,
    label: t('innerLayout.balanceTransfers.transfers.tabs.failed'),
  },
];
